import { Loading } from "components/shared";
import { Button } from "components/ui";
import InputModern from "components/ui/Input/InputModern";
import React, { useEffect, useState } from "react";
import { HiOutlineUser } from "react-icons/hi2";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";

const ChangeAudience = ({ audience, ...props }) => {

    const [ customAudience, setCustomAudience ] = useState("");
    const { isLoading, input, run, writeBackReplace, closeMenu } = useMagicAction(props);

    const handleChangeAudience = (targetAudience) => {
        run({
            prompt: `Rewrite the following text so it speaks to this audience: ${targetAudience}.\n\nTEXT:\n${input}`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackReplace(asText(r)))
            .finally(closeMenu);
    }

    const handleOnClick = () => {
        handleChangeAudience(customAudience ? customAudience : audience);
    }

    useEffect(() => {
        if (audience) {
            handleChangeAudience(audience);
        }
    }, []);

    return (
        <div className="flex items-center justify-center p-0 gap-2">
            {isLoading
                ? <Loading type={'element'} />
                :
                <div className="flex flex-col gap-2 w-full">
                    <InputModern
                        autoFocus
                        value={customAudience}
                        onChange={(e) => setCustomAudience(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !isLoading) {
                                e.preventDefault();
                                handleOnClick();
                            }
                        }}
                        placeholder={`Try "Small Business Owners"`}
                    />
                    <div className="items-center w-full">
                        <Button loading={isLoading} disabled={isLoading} onClick={handleOnClick} className="w-full" variant="solid" icon={<HiOutlineUser />}>&nbsp; Change Audience</Button>
                    </div>
                </div>
            }

        </div>
    )
}

export default ChangeAudience;
